import MDBox from "components/MDBox";
import MDButton from "components/MDButton";

import { Grid, IconButton, TextField } from "@mui/material";
import { useQuery } from "@tanstack/react-query";
import { FormTitle, Text, SelectField } from "ui-components/Form";
import Fieldset from "layouts/views/components/Fieldset";
// import ClickableTablePF from "./ClickableTablePF";
import { OldSelectField } from "./OldSelectFieldPF";

import { useState, useEffect } from "react";
import { getRackList, getLocationsByRack } from "services/data.internal.service";
import { useZoneOptionsQuery } from "hooks/useZoneQuery";

import {
  getVendorOptions,
  getCategoryOptions,
  getGroupOptions,
  getSubGroupOptions,
  getSKUListByVendCode,
  getPickFaceLocation,
} from "services/data.internal.service";
import { getVendorWithCustCode } from "services/data.internal.service";
import { getLocationsSetAsPreferred } from "services/data.internal.service";
import { getCustomersByWarehouse } from "services/data.internal.service";
import { SelectFields } from "ui-components/Form";
import { StripedDataGrid } from "layouts/views/components/Grid";
import { EditableSelectCustomOnChange } from "ui-components/EditableInput2";
import styled from "@emotion/styled";
import { selectionColumns } from "./column";
import { useGridApiContext } from "@mui/x-data-grid";
import { Error_ } from "ui-components/Alert";
import { useCustWhOptionsQuery } from "hooks/useQueryHook";

const EditableStyledDataGrid = styled(StripedDataGrid)({
  ".custom-editable-header": {
    backgroundColor: "#1A73E8 !important",
    color: "#fff",
    fontWeight: "bold",
    whiteSpace: "normal !important",
  },
  ".MuiDataGrid-columnHeaderTitle": {
    whiteSpace: "normal !important",
    lineHeight: 1,
  },
  ".MuiDataGrid-columnHeader": {
    backgroundColor: "#f0f2f5",
  },
  ".MuiDataGrid-cell": {
    whiteSpace: "normal !important",
    "word-wrap": "break-word !important",
  },
  ".right-align-header": {
    textAlign: "right",
  },
  ".highlight": {
    backgroundColor: "pink !important",
  },
});

const uomTypeOpt = ["BASE", "INNERPACK", "CASE", "PALLET"];

const customColumn = selectionColumns.map((x) => {
  if (x.field === "qtyToReplenish") {
    x.headerClassName = "custom-editable-header right-align-header";
    x.editable = true;
  }
  if (x.field === "uomType") {
    x.headerClassName = "custom-editable-header";
    x.editable = true;
    x.renderEditCell = (params) => {
      return <CustomPicker options={uomTypeOpt} {...params} />;
    };
  }
  return x;
});

const CustomPicker = (props) => {
  const { options, ...params } = props;
  const [selectedVal, setSelectedVal] = useState(params.value ? params.value : null);

  const apiRef = useGridApiContext();

  const handleValChange = async (e, value) => {
    setSelectedVal(value);
    await apiRef.current.setEditCellValue({
      id: params.id,
      field: params.field,
      value: value,
    });
  };

  return (
    <EditableSelectCustomOnChange
      getValue={() => selectedVal}
      onChange={handleValChange}
      options={options}
      style={{ width: "100%" }}
    />
  );
};

function PickFaceLocationInfo(props) {
  const {
    formRender,
    control,
    errors,
    setValue,
    watch,
    customerCode,
    locationsId,
    setLocationsId,
    // selectedCells,
    // setSelectedCells,
    skuOptions,
    setSkuOptions,
    selectedSKU,
    setSelectedSKUs,
    prefLoc,
    setPrefLoc,
    setAlert,
  } = props;

  //test render
  const [warehouseCode, zoneID, rack, locationID, levelSetting] = watch([
    "warehouseCode",
    "zoneID",
    "rack",
    "locationID",
    "levelSetting",
  ]);

  const [locationSelection, setLocationSelection] = useState([]);

  useEffect(() => {
    if (zoneID !== null) setValue("zoneID", null);
  }, [warehouseCode]);

  useEffect(() => {
    if (rack !== null) setValue("rack", null);
  }, [zoneID]);

  useEffect(() => {
    if (Boolean(locationID)) setValue("locationID", []);
    // if (selectedCells.length !== 0) {
    //   setSelectedCells([]);
    // }
    if (rack === null && locationsId.length !== 0) setLocationsId([]);
    if (Boolean(locationSelection)) setLocationSelection([]);
  }, [rack]);

  useEffect(() => {
    if (Boolean(locationSelection)) setValue("locationID", locationSelection);
  }, [locationSelection]);

  const [existingLocation, setExistingLocation] = useState([]);
  const [existingDetail, setExistingDetail] = useState([]);

  const [warehouseOptions, setWarehouseOptions] = useState([]);
  const [zoneOptions, setZoneOptions] = useState([]);
  const [rackOptions, setRackOptions] = useState([]);
  const [locationsId2, setLocationsId2] = useState([]);
  useCustWhOptionsQuery({
    customerCode,
    onSuccess: (data) => {
      const options = data.data.data
        .map((v) => v)
        .sort((a, b) => a.toLowerCase().localeCompare(b.toLowerCase()));
      setWarehouseOptions([...options]);
    },
  });
  useZoneOptionsQuery({
    whCode: warehouseCode,
    zoneType: "Storage",
    enabled: warehouseCode != null,
    onSuccess: (data) => {
      const options = data.data.data
        .map((v) => v)
        .sort((a, b) => a.toLowerCase().localeCompare(b.toLowerCase()));
      setZoneOptions([...options]);
    },
  });
  const rackListReq = {
    whCode: warehouseCode,
    id: zoneID,
    rack: rack,
  };
  useQuery({
    queryKey: ["racks", warehouseCode, zoneID],
    queryFn: () => {
      if (warehouseCode && zoneID) return getRackList(rackListReq);
      return {};
    },
    refetchOnWindowFocus: false,
    enabled: warehouseCode != null && zoneID != null,
    onSuccess: (data) => {
      if (data.data) {
        setRackOptions(
          data.data.map((r) => r).sort((a, b) => a.toLowerCase().localeCompare(b.toLowerCase()))
        );
      }
    },
  });
  useQuery({
    queryKey: ["locations", rack],
    queryFn: () => {
      if (rack) return getLocationsByRack(rackListReq);
      return {};
    },
    refetchOnWindowFocus: false,
    enabled: warehouseCode != null && zoneID != null && rack != null,
    onSuccess: (data) => {
      if (data.data) {
        setLocationsId2(
          data.data.sort((a, b) =>
            a.locationID.toLowerCase().localeCompare(b.locationID.toLowerCase())
          )
        );
        // const locations = data.data;
        // let maxRow = Math.max.apply(
        //   Math,
        //   locations.map((x) => x.lLevel)
        // );
        // let maxColumn = Math.max.apply(
        //   Math,
        //   locations.map((x) => x.bay)
        // );
        // let numberOfSlot = Math.max.apply(
        //   Math,
        //   locations.map((x) => x.slot)
        // );
        // if (numberOfSlot > 0) maxColumn = maxColumn * numberOfSlot;
        // let table = [];
        // for (var i = 0; i < maxRow; i++) {
        //   let row = Array(maxColumn).fill("");
        //   let locationsInRow = locations.filter((x) => x.lLevel === i + 1);
        //   if (locationsInRow.length > 0) {
        //     for (var j = 0; j < locationsInRow.length; j++) {
        //       let index = (locationsInRow[j].bay - 1) * numberOfSlot + locationsInRow[j].slot - 1;
        //       row[index] = locationsInRow[j].locationID;
        //     }
        //   }
        //   table.unshift(row);
        // }
        // setLocationsId(table);
      } else {
        // setLocationsId([]);
        // setSelectedCells([]);
        // setRoutingDirection("no-direction");
      }
    },
  });

  useQuery({
    queryKey: ["existing-pref-loc", rack],
    queryFn: () => getLocationsSetAsPreferred(rackListReq),
    refetchOnWindowFocus: false,
    enabled: warehouseCode != null && zoneID != null && rack != null,
    onSuccess: (data) => {
      const loc = data.data.data.map((v) => v);
      setPrefLoc([...loc]);
    },
  });

  const levelOptions = ["Customer-level", "Vendor-level", "SKU-level"];

  const [vendorCodeOptions, setVendorCodeOptions] = useState([]);
  const [categoryOptions, setCategoryOptions] = useState([]);
  const [groupOptions, setGroupOptions] = useState([]);
  const [subgroupOptions, setSubGroupOptions] = useState([]);
  const [vendorCode, setVendorCode] = useState(null);
  const [category, setCategory] = useState(null);
  const [group, setGroup] = useState(null);
  const [subgroup, setSubGroup] = useState(null);
  const [skuCodes, setSKUCodes] = useState("");

  useQuery({
    queryKey: ["vendor-options", customerCode],
    queryFn: () => getVendorOptions({ custCode: customerCode }),
    refetchOnWindowFocus: false,
    enabled: customerCode !== null,
    onSuccess: (data) => {
      setVendorCodeOptions(data.data.data.map((x) => x));
    },
  });
  useQuery({
    queryKey: ["category-options", [customerCode, vendorCode]],
    queryFn: () => getCategoryOptions({ custCode: customerCode, vendCode: vendorCode }),
    refetchOnWindowFocus: false,
    enabled: customerCode !== null,
    onSuccess: (data) => {
      setCategoryOptions(data.data.data.map((x) => x));
    },
  });
  useQuery({
    queryKey: ["group-options", [customerCode, vendorCode]],
    queryFn: () => getGroupOptions({ custCode: customerCode, vendCode: vendorCode }),
    refetchOnWindowFocus: false,
    enabled: customerCode !== null,
    onSuccess: (data) => {
      setGroupOptions(data.data.data.map((x) => x));
    },
  });
  useQuery({
    queryKey: ["subgroup-options", [customerCode, vendorCode]],
    queryFn: () => getSubGroupOptions({ custCode: customerCode, vendCode: vendorCode }),
    refetchOnWindowFocus: false,
    enabled: customerCode !== null,
    onSuccess: (data) => {
      setSubGroupOptions(data.data.data.map((x) => x));
    },
  });

  const [loadSKU, setLoadSKU] = useState(false);
  const [loadPFLoc, setLoadPFLoc] = useState(false);

  //load exisitng location when pressed Load SKU, and plot table

  const loadSKUList = () => {
    setLoadSKU(!loadSKU);
    setLoadPFLoc(!loadPFLoc);
  };

  const SKUReq = {
    custCode: customerCode,
    vendCode: vendorCode,
    category: category,
    group: group,
    subgroup: subgroup,
    skuCodes: skuCodes
  };
  useQuery({
    queryKey: ["sku-options", [customerCode, vendorCode, category, group, subgroup, skuCodes]],
    queryFn: () => getSKUListByVendCode(SKUReq),
    enabled: loadSKU,
    onSuccess: (data) => {
      let result = data.data.data.map((x) => ({
        id: `${x.customerCode}_${x.vendorCode}_${x.skuCode}`,
        skuCode: x.skuCode,
        customerCode: x.customerCode,
        vendorCode: x.vendorCode,
        category: x.category,
        group: x.skuGroup,
        subgroup: x.skuSubGroup,
        qtyToReplenish: null,
        uomType: null,
      }));
      setSkuOptions(result);
      setLoadSKU(!loadSKU);
    },
  });
  useQuery({
    queryKey: ["existing-pickface-location", [warehouseCode, zoneID, rack, customerCode]],
    queryFn: () =>
      getPickFaceLocation({
        warehouseCode: warehouseCode,
        zoneID: zoneID,
        rack: rack,
        customerCode: customerCode,
      }),
    enabled: skuOptions.length > 0 && locationsId.length > 0,
    onSuccess: (data) => {
      let result = data.data.data.pickFaceLocationDetails;
      const tempLoclist = [];
      const tempDetList = [];
      result.forEach((detail) => {
        const { locationId, skuCode, customerCode, vendorCode, ...remaining } = detail;

        const locationIndex = tempLoclist.findIndex((current) => current === locationId);
        if (locationIndex === -1) {
          tempLoclist.push(locationId);
        }

        const itemIndex = tempDetList.findIndex(
          (data) =>
            data.skuCode === skuCode &&
            data.customerCode === customerCode &&
            data.vendorCode === vendorCode
        );
        if (itemIndex === -1) {
          tempDetList.push({
            skuCode,
            vendorCode,
            customerCode,
            locations: [locationId],
          });
        } else {
          tempDetList[itemIndex].locations.push(locationId);
        }
      });
      setExistingLocation(tempLoclist);
      setExistingDetail(tempDetList);
    },
  });

  useEffect(() => {
    if (levelSetting === "SKU-level" && skuOptions.length > 0) setSkuOptions([]);
    setValue("selection", null);
    setSelectedSKUs([]);
  }, [levelSetting]);

  useQuery({
    queryKey: ["customer-options-for-pickFace", [warehouseCode]],
    queryFn: () => getCustomersByWarehouse({ warehouseCode: warehouseCode }),
    enabled: levelSetting === "Customer-level" && Boolean(warehouseCode),
    onSuccess: (data) => {
      let result = data.data.data.map((x) => {
        return {
          id: `${x}_${undefined}_${undefined}`,
          skuCode: "",
          customerCode: x,
          vendorCode: "",
          category: "",
          group: "",
          subgroup: "",
          qtyToReplenish: null,
          uomType: null,
        }
      });
      setSkuOptions(result);
    },
  });

  useQuery({
    queryKey: ["vendor-customer-options", [warehouseCode]],
    queryFn: () => getVendorWithCustCode({ warehouseCode: warehouseCode }),
    enabled: levelSetting === "Vendor-level" && Boolean(warehouseCode),
    onSuccess: (data) => {
      let result = data.data.data.map((x) => ({
        id: `${x.customerCode}_${x.vendorCode}_${x.skuCode}`,
        skuCode: "",
        customerCode: x.customerCode,
        vendorCode: x.vendorCode,
        category: "",
        group: "",
        subgroup: "",
        qtyToReplenish: null,
        uomType: null,
      }));
      setSkuOptions(result);
    },
  });

  function renderFn(property, index, length) {
    const { xs, disabled, edit, ...data } = property;
    //custom xs
    const xs2 = xs ? xs : 12 / length;
    const fieldProps = {
      ...data,
      control,
      errors,
    };

    const handleProcessRowUpdateError = (error) => {
      setAlert(<Error_ content={error.toString()} onChange={setAlert} />);
    };

    const handleRowUpdate = (updatedRow, originalRow) => {
      if (JSON.stringify(updatedRow) !== JSON.stringify(originalRow)) {
        if (!selectedSKU.some((x) => x === updatedRow.id)) {
          setSelectedSKUs([...selectedSKU, updatedRow.id]);
        }

        const newSKU = skuOptions.map((x) => {
          if (
            x.customerCode === updatedRow.customerCode &&
            x.skuCode === updatedRow.skuCode &&
            x.vendorCode === updatedRow.vendorCode
          ) {
            const updatedRowCopy = { ...x };
            updatedRowCopy.qtyToReplenish = updatedRow.qtyToReplenish;
            if (uomTypeOpt.some((uom) => uom === updatedRow.uomType)) {
              updatedRowCopy.uomType = updatedRow.uomType;
            } else {
              updatedRowCopy.uomType = null;
            }
            return updatedRowCopy;
          }
          return x;
        });

        setSkuOptions(newSKU);
      }
      return updatedRow;
    };

    const selectRow = (id) => {
      if (selectedSKU.length > id.length) {
        const removed = selectedSKU.filter((x) => !id.includes(x));
        let updatedRow = skuOptions;
        removed.forEach((removedID) => {
          updatedRow = updatedRow.map((x) => {
            if (removedID === x.id) {
              return {
                ...x,
                qtyToReplenish: null,
                uomType: null,
              };
            } else return x;
          });
        });
        setSkuOptions(updatedRow);
      }
      setSelectedSKUs(id);
    };

    const isCellEditable = (params) => {
      if (params.field === "qtyToReplenish" || params.field === "uomType") {
        return levelSetting === "SKU-level";
      }
      return false;
    };

    let renderField;
    if (data.type === "text" || data.type === "number") {
      renderField = <Text field={fieldProps} />;
    } else if (data.type === "select") {
      if (!data.multiple) {
        renderField = (
          <SelectField
            field={fieldProps}
            options={
              (data.name === "warehouseCode" && warehouseOptions) ||
              (data.name === "zoneID" && zoneOptions) ||
              (data.name === "rack" && rackOptions) ||
              (data.name === "levelSetting" && levelOptions)
            }
            control={control}
            errors={errors}
          />
        );
      } else if (data.multiple) {
        // if (data.name === "locationID" && locationsId.length !== 0) {
        //   renderField = (
        //     <>
        //       <Grid container spacing={3}>
        //         <Grid item xs={6}>
        //           <MDBox pt={1} pb={2}>
        //             <MDTypography color="info" variant="h5">
        //               Select Location
        //             </MDTypography>
        //           </MDBox>
        //         </Grid>
        //       </Grid>
        //       <Grid container spacing={3}>
        //         <Grid item xs={12}>
        //           <ClickableTablePF
        //             tableData={locationsId}
        //             values={locationID}
        //             fieldName={data.name}
        //             setFieldValue={setValue}
        //             selectedCells={selectedCells}
        //             setSelectedCells={setSelectedCells}
        //             existingLocation={existingLocation}
        //             prefLoc={prefLoc}
        //           />
        //         </Grid>
        //       </Grid>
        //     </>
        //   );
        // }
        if (data.name === "selection" && levelSetting !== "All customer, vendor and SKU") {
          const custProp = {
            disabled: true,
            value: customerCode || "",
            required: true,
            name: "customerCode",
            label: "Customer Code",
          };
          renderField = (
            <Fieldset label={data.label}>
              {levelSetting === "SKU-level" && (
                <>
                  <Grid container spacing={3}>
                    <Grid item xs={6}>
                      <TextField sx={{ mb: 1.5 }} {...custProp} fullWidth />
                    </Grid>
                    <Grid item xs={6}>
                      <OldSelectField
                        field={{
                          name: "vendorCode",
                          label: "Vendor Code",
                          value: vendorCode || null,
                        }}
                        options={vendorCodeOptions}
                        onChange={(e, option) => setVendorCode(option)}
                      />
                    </Grid>
                  </Grid>
                  <Grid container spacing={3}>
                    <Grid item xs={6}>
                      <OldSelectField
                        field={{ name: "category", label: "Category", value: category || null }}
                        options={categoryOptions}
                        onChange={(e, option) => setCategory(option)}
                      />
                    </Grid>
                    <Grid item xs={6}>
                      <OldSelectField
                        field={{ name: "group", label: "SKU Group", value: group || null }}
                        options={groupOptions}
                        onChange={(e, option) => setGroup(option)}
                      />
                    </Grid>
                  </Grid>
                  <Grid container spacing={3}>
                    <Grid item xs={6}>
                      <OldSelectField
                        field={{
                          name: "subgroup",
                          label: "SKU Sub Group",
                          value: subgroup || null,
                        }}
                        options={subgroupOptions}
                        onChange={(e, option) => setSubGroup(option)}
                      />
                    </Grid>
                    <Grid item xs={6}>
                      <TextField
                        label="Search SKU Code (split by comma ,) - Max 10"
                        fullWidth
                        value={skuCodes}
                        onChange={(e) => setSKUCodes(e.target.value)}
                      />
                    </Grid>
                  </Grid>
                  <Grid container spacing={3}>
                    <Grid item xs={12}>
                      <MDBox
                        mt={2}
                        width="100%"
                        display="flex"
                        style={{ marginBottom: "10px" }}
                        justifyContent="center"
                      >
                        <MDButton color="info" variant="gradient" onClick={loadSKUList}>
                          Load SKU
                        </MDButton>
                      </MDBox>
                    </Grid>
                  </Grid>
                </>
              )}
              {skuOptions.length > 0 && (
                <Grid container spacing={3}>
                  <Grid item xs={12}>
                    <div style={{ height: 500, width: "100%" }}>
                      <EditableStyledDataGrid
                        autoHeight={false}
                        columns={customColumn}
                        rows={skuOptions}
                        checkboxSelection={true}
                        disableRowSelectionOnClick={true}
                        onRowSelectionModelChange={selectRow}
                        rowSelectionModel={selectedSKU}
                        sx={{
                          borderRadius: "0.75rem",
                        }}
                        initialState={{
                          pagination: { paginationModel: { pageSize: 25 } },
                        }}
                        getRowHeight={() => "auto"}
                        processRowUpdate={handleRowUpdate}
                        onProcessRowUpdateError={handleProcessRowUpdateError}
                        hideFooterSelectedRowCount={true}
                        isCellEditable={isCellEditable}
                      />
                    </div>
                    {/* <ClickableListboxPF
                      options={skuOptions}
                      selectedSKUs={selectedSKU}
                      setSelectedSKUs={setSelectedSKUs}
                      existingDetail={existingDetail}
                    /> */}
                  </Grid>
                </Grid>
              )}
              {/* {selection !== null && selection.length !== 0 && (
                <Grid container spacing={3}>
                  <Grid item xs={12}>
                    <DataTable
                      table={{
                        columns: [
                          { Header: "SKU Code", accessor: "skuCode" },
                          { Header: "Customer Code", accessor: "customerCode" },
                          { Header: "Vendor Code", accessor: "vendorCode" },
                          { Header: "Existing Location", accessor: "existingLocation" },
                          { Header: "Action", accessor: "action" },
                        ],
                        rows: selection.map((d) => {
                          const loc =
                            existingDetail.findIndex(
                              (det) =>
                                det.skuCode === d.skuCode &&
                                det.customerCode === d.customerCode &&
                                det.vendorCode === d.vendorCode
                            ) !== -1
                              ? existingDetail
                                  .find(
                                    (det) =>
                                      det.skuCode === d.skuCode &&
                                      det.customerCode === d.customerCode &&
                                      det.vendorCode === d.vendorCode
                                  )
                                  .locations.join(", ")
                              : "";
                          return {
                            skuCode: d.skuCode,
                            customerCode: d.customerCode,
                            vendorCode: d.vendorCode,
                            existingLocation: loc,
                            action: (
                              <MDBox>
                                <IconButton
                                  color="error"
                                  title="remove pick face location"
                                  onClick={() => {
                                    let updated = [...selectedSKU];
                                    updated = updated.filter(
                                      (prev) =>
                                        prev.skuCode !== d.skuCode ||
                                        prev.customerCode !== d.customerCode ||
                                        prev.vendorCode !== d.vendorCode
                                    );
                                    setSelectedSKUs(updated);
                                  }}
                                >
                                  <CancelButton />
                                </IconButton>
                              </MDBox>
                            ),
                          };
                        }),
                      }}
                    />
                  </Grid>
                </Grid>
              )} */}
            </Fieldset>
          );
        }
      }
    } else if (data.type === "multi-select") {
      if (data.name === "locationID") {
        renderField = (
          <SelectFields
            field={{
              name: "",
              label: "Location ID",
              value: locationSelection,
              errors: {},
              multiple: true,
              required: true,
            }}
            options={locationsId2
              .map((x) => x.locationID)
              .filter((x) => !prefLoc.some((z) => z == x))}
            onChange={(e, v) => setLocationSelection(v)}
          />
        );
      }
    }
    return (
      <Grid key={index} item xs={xs2}>
        {renderField}
      </Grid>
    );
  }

  return (
    <MDBox>
      <FormTitle title="New Pick Face Location Information" />

      <MDBox mt={1.625}>
        {formRender.map((renders, i) => {
          if (renders[0].name === "selection")
            return <>{renders.map((render, index) => renderFn(render, index, renders.length))}</>;
          else
            return (
              <Grid container spacing={3} key={i}>
                {renders.map((render, index) => renderFn(render, index, renders.length))}
              </Grid>
            );
        })}
      </MDBox>
    </MDBox>
  );
}

export default PickFaceLocationInfo;
